import { DestroyableObstacle } from "../destroyableObstacle";
import type { XY } from "../xy";

export abstract class SolidifiedMob extends DestroyableObstacle {
	constructor(xy: XY) {
		super(xy);
	}
}
